<template>
  <div id="app">
    <router-view></router-view>
    <iframe :src="iframeUrl" width="2" height="2" style="display:none"></iframe>
  </div>
</template>
<script>
import { hzZhanhui } from "../utils/common";
export default {
  data() {
    return {
      token: "",
      viewToken: "",
      iframeUrl: "",
    };
  },
  methods: {
    init() {
      let token = "";
      if (
        localStorage.getItem("token") != "" &&
        localStorage.getItem("token") != null
      ) {
        token = localStorage.getItem("token");
      }
      let viewToken = "";
      if (
        localStorage.getItem("viewToken") != "" &&
        localStorage.getItem("viewToken") != null
      ) {
        viewToken = localStorage.getItem("viewToken");
      }

      this.iframeUrl =
        hzZhanhui() + "/syncLogin?token=" + token + "&viewToken=" + viewToken;
    },
  },
  mounted() {
     this.init()

    window.addEventListener("storage", (event) => {
      this.init()
    });
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
body {
  // min-width: 1270px;
}
html {
  // min-width: 1270px !important;
}

//当页面是微信注册页面消除min-width
@media only screen and (max-width: 1270px) {
  body {
    // min-width: auto;
  }
}
</style>






















